module.exports = __webpack_public_path__ + "img/vip1.9903e9e4.png";